import { Navigate } from 'react-router-dom-latest';
import { BROKER_SITE_ROLES, LocalStorage, PORTAL_SITE_ROLES, UserRole } from 'enums';
import { useCurrentUser, useLocalStorage } from 'hooks';
import { User } from 'types';
import { BROKER_ROUTES } from 'broker/broker-routes';

function getPath({ role }: User) {
  if (BROKER_SITE_ROLES.includes(role)) {
    return `${BROKER_ROUTES.SUBMISSION_BOX}`;
  }

  if (PORTAL_SITE_ROLES.includes(role)) {
    return `${BROKER_ROUTES.PORTAL}`;
  }

  return role.toLowerCase();
}

function OpExRedirect() {
  const [selectedMarketId] = useLocalStorage<string | null>(LocalStorage.OpExSelectedMarketId, null);

  const path = selectedMarketId ? BROKER_ROUTES.SUBMISSION_QUEUE : BROKER_ROUTES.SUBMISSION_SERVICES;

  return <Navigate to={`/${path}`} />;
}

export default function DefaultLoggedInRedirect() {
  const { endUser } = useCurrentUser();

  if (endUser === null) {
    // should never happen due to ProtectedRoute
    return null;
  }

  if (endUser.role === UserRole.OpEx) {
    return <OpExRedirect />;
  }

  const path = `/${getPath(endUser)}`;

  return <Navigate to={path} />;
}
